import React from "react";
import {pageAuthorizedByGroup} from "../fragments/PageAuthorization";
import {Button, Card, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {translateFunction} from "../../localization/TranslationService";
import {ListAlt, ViewWeek, Quiz} from "@mui/icons-material";
import {EnvironmentStage} from "../../data/EnvironmentStage";

const translate = translateFunction("SureBasePortalDynamicForms");

/*
* overview
*
* forms
*   - table with all forms
*
* forms/:id
*   - full form definition
*   - preview of how it would look like
*
* questions
*   - table with all questions
*
* questions/:id
*   - full question definition
*   - preview of how it would look like
*
* */

function DynamicFormsOverview() {
	return <>
		<Stack direction={"row"} justifyContent={"space-evenly"} style={{width: "100%"}}>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ListAlt fontSize={"large"}/>
						<Typography>{translate("Forms")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./forms"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Quiz fontSize={"large"}/>
						<Typography>{translate("Questions")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./questions"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ViewWeek fontSize={"large"}/>
						<Typography>{translate("Changes")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./deploy"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
		</Stack>
	</>;
}

export const DynamicFormsOverviewPage = pageAuthorizedByGroup(DynamicFormsOverview, ["Admin", "DynamicForms"]);

export const dynamicFormsDefaultTargetStage: EnvironmentStage = "dev";
export const dynamicFormsTargetStage = "kizidev";
